import { SET_SSO_TOKEN } from "../constants"

export default function setSSOToken(token) {
    return {
        type: SET_SSO_TOKEN,
        payload: { token }
    }
}
